import { useEffect } from 'react';

type SeoProps = {
  title: string;
  description: string;
  canonical: string;
  image?: string;
};

export default function Seo({
  title,
  description,
  canonical,
  image = 'https://joshuawhastings.com/assets/images/background-shade.jpg',
}: SeoProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (
      selector: string,
      attribute: 'name' | 'property',
      key: string,
      content: string,
    ) => {
      let element = document.head.querySelector(
        selector,
      ) as HTMLMetaElement | null;

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    setMeta('meta[name="description"]', 'name', 'description', description);

    setMeta('meta[property="og:title"]', 'property', 'og:title', title);

    setMeta(
      'meta[property="og:description"]',
      'property',
      'og:description',
      description,
    );

    setMeta('meta[property="og:url"]', 'property', 'og:url', canonical);

    setMeta('meta[property="og:image"]', 'property', 'og:image', image);

    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title);

    setMeta(
      'meta[name="twitter:description"]',
      'name',
      'twitter:description',
      description,
    );

    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image);

    let canonicalLink = document.head.querySelector(
      'link[rel="canonical"]',
    ) as HTMLLinkElement | null;

    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }

    canonicalLink.setAttribute('href', canonical);
  }, [title, description, canonical, image]);

  return null;
}
